<script setup>
import useCategoryTable from "./hooks/useCategoryTable";
import useCategoryEdit from "./hooks/useCategoryEdit";
import Adjust from "./adjust.vue";
import FileUpload from "@/components/FileUpload.vue";
import { uploadExcelData } from "@/api/materiel";
import { onMounted } from "vue";

const {
  searchData,
  searchRef,
  columns,
  tableData,
  tableLoading,
  pageParams,
  uploadRef,
  uploadConfig,
  getList,
  handleReset,
  handleUpload,
  handleDownload,
} = useCategoryTable();

const { editRef, handleEdit, handleDelete, handleEnable } =
  useCategoryEdit(getList);

onMounted(() => {
  getList();
});
</script>

<template>
  <div class="page-container">
    <div class="layout-header">
      <div>物料类别</div>
      <div>
        <!-- 按钮 -->
        <el-button type="primary" icon="Plus" @click="handleEdit(null, true)"
          >新增</el-button
        >
      </div>
    </div>
    <div class="main-pane">
      <!-- 搜索栏 -->
      <el-form :model="searchData" ref="searchRef">
        <el-row :gutter="10">
          <el-col :xl="4" :sm="6">
            <el-form-item label="类别名称：" prop="name">
              <el-input v-model="searchData.name" placeholder="请输入名称" />
            </el-form-item>
          </el-col>
          <el-col :xl="4" :sm="6">
            <el-form-item label="类别编号：" prop="number">
              <el-input v-model="searchData.number" placeholder="请输入编码" />
            </el-form-item>
          </el-col>
          <el-col :xl="4" :sm="6">
            <el-form-item label="状态：" prop="status">
              <el-select v-model="searchData.status">
                <el-option label="启用" value="1" />
                <el-option label="停用" value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="4" :sm="6">
            <el-form-item>
              <el-button type="primary" icon="Search" @click="getList()"
                >查询</el-button
              >
              <el-button icon="Refresh" @click="handleReset()">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button icon="Upload" @click="handleUpload()">导入</el-button>
          <el-button icon="Download" @click="handleDownload()">导出</el-button>
        </el-row>
      </el-form>

      <!-- 表格 -->
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{
          'text-align': 'center',
        }"
        style="width: 100%; margin-top: 10px"
        max-height="650"
        :data="tableData"
        v-loading="tableLoading"
      >
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :width="item.width || ''"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <span v-if="item.prop == 'status'">{{
                row[item.prop]?.desc
              }}</span>
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleEdit(row, false)"
              >编辑</el-button
            >
            <el-button type="danger" link @click="handleDelete(row)"
              >删除</el-button
            >
            <!-- <el-button type="primary" link @click="handleEnable(row, false)"
              >停用</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="pageParams.total > 0"
        background
        style="margin-top: 10px"
        :current-page="pageParams.page"
        :page-size="pageParams.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="pageParams.total"
        layout="->, total, prev, pager, next, sizes, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 新增编辑弹窗 -->
    <Adjust ref="editRef" @afterSave="getList" />
    <!-- 文件导入 -->
    <FileUpload
      ref="uploadRef"
      @afterUpload="getList"
      :fn="uploadExcelData"
      :uploadConfig="uploadConfig"
    />
  </div>
</template>

<style scoped></style>
